module.exports = __webpack_public_path__ + "assets/93dc775003e38662abb8fee23106a876.png";